//import libraries
import React, { Component } from 'react';
import Parser from 'html-react-parser';

//import Components

//import Styles
import '../Blog.css';

const blogItem = (props) => {
    const { totalLength, addClass, data, index, text, onTitleClick, openList } = props; 

    const renderContent = openList === data.id ? Parser(text) : '';
    return (
        <div className={"List " + addClass}>
            <div className="TitleBar"
                onClick={() => {
                    onTitleClick(data.id)
                }}
            >
                <li><p>{totalLength - index}</p></li>
                <li><strong>{data.title}</strong></li>
                <li><p>{data.date}</p></li>
                {/* <li><p>조회수 {data.view}</p></li> */}
            </div>
            <div className="HiddenContent">
            {
                renderContent
            }
            </div>
        </div>

    );
}

export default blogItem;


// WEBPACK FOOTER //
// ./src/pages/Community/Blog/BlogItem/BlogItem.js